import React from 'react';
import {
	FileInvoiceReturnButton,
	InvoiceReturnLines,
	OriginalInvoiceField
} from '../components';

const modelName = 'invoicereturn';

const hasParty = values =>
	(values.partyType === 'client' && values.systemParty === true) ||
	values.partyType === 'vendor';

export default {
	model: modelName,
	elements: [
		{
			field: 'invoiceId',
			component: OriginalInvoiceField
		},
		{
			field: 'returnNumber',
			readOnly: true,
			display: ({ values }) => values.status === 'active'
		},
		{
			field: 'status',
			readOnly: true,
			display: ({ values, mode }) => values.id && mode === 'view'
		},
		{
			field: 'storeId',
			readOnly: true,
			display: ({ values }) => values.storeId
		},
		{
			field: 'partyType',
			readOnly: true,
			display: ({ values }) => values.partyType
		},
		{
			field: 'partyName',
			readOnly: true,
			display: ({ values }) => values.partyName && !hasParty(values)
		},
		{
			field: 'partyId',
			readOnly: true,
			display: ({ values }) => values.partyId && hasParty(values)
		},
		{ field: 'returnDate' },
		{ field: 'reason' },
		{
			field: 'totalPrice',
			readOnly: true,
			display: ({ values }) => values.invoiceId
		},
		{
			field: 'returnStatus',
			readOnly: true,
			display: ({ values, mode }) => values.id && mode === 'view'
		},
		{
			field: 'etaReturnStatus',
			readOnly: true,
			display: ({ values, mode, user }) =>
				values.id && mode === 'view' && user.role === 'admin'
		},
		{
			field: 'etaReturnId',
			component: FileInvoiceReturnButton,
			display: ({ values, mode, user }) =>
				values.id &&
				mode === 'view' &&
				user.role === 'admin' &&
				values.status === 'active'
		},
		{
			width: 12,
			component: function invoiceReturnLines(props) {
				return <InvoiceReturnLines {...props} />;
			}
		}
	]
};
